import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable()
export class IsLoggedIn {
  constructor(
    private router: Router, 
    private authService: AuthService) {
  }

  resolve(): void {
    if (this.authService.token) {
        if (this.authService.roles.indexOf("administrador") > -1) {
            this.router.navigate(['dashboard/clientes']);
          } else if (this.authService.roles.indexOf("usuario") > -1) {
            this.router.navigate(['clientes']);
          }else if (this.authService.roles.indexOf("intranet") > -1) {
            this.router.navigate(['intranet/kairos']);
          }
    }
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/services/guards/is-logged-in.ts